import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import { Checkbox, Group, Stack, TextInput } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import { NumericFormat } from 'react-number-format';
import { connect } from 'react-redux';
import Autoload from '../../../../Autoload';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class FailedInvoicesSettlementModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    failedInvoices: []
  };
  
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    //this.getInvoices();
  }

  getInvoices=()=>{
    const userAccountID = this.props.profile.accountId;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'Invoices?accountId=' + userAccountID,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetInvoices',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleGetInvoices(response){
    if(response.status && response.statuscode === 200){
      if(response.result.length > 0){
        let failedInvoices = response.result.filter((invoice)=> invoice.paymentStatus	=== 'FAILED');
        if(failedInvoices.length > 0){
          this.setState({failedInvoices});
        }
      }
    }
  }

  settleInvoices=()=>{
    this.props.toggle();
  }
  
  render() {
    const { open, toggle, className, update } = this.props;
    const {failedInvoices} = this.state;
    
    return (
      <CustomModal
        heading={'Fehlgeschlagene Rechnungen erkannt'}
        headingClassName={'settle-failed-payments-modal-heading'}
        open={open}
        toggle={() => {
          toggle();
        }}
        className={`${className}`}
      >
        <Stack>
            <Stack gap={5}>
              <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>In Ihrem Account sind derzeit Rechnungen vorhanden, deren Zahlung nicht möglich war. Um den vollen Zugriff auf hellohousing wiederherzustellen, begleichen Sie bitte die ausstehenden Beträge.</span>
              {/* <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>{failedInvoices.map((invoice, index)=> (index > 0 ? ' ' : '') + invoice.invoiceNumber + (index < (failedInvoices.length-1) ? ',' : ''))}</span> */}
            </Stack>
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Zahlungen prüfen'}
                    className='purple-btn'
                    onClick={()=> this.settleInvoices()}
                    />
                </div>
            </Group>
        </Stack>
      </CustomModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.generalReducer.profile,
    currentSubscription: state.generalReducer.currentSubscription,
    accountData: state.generalReducer.accountData
  };
};

export default connect(mapStateToProps)(FailedInvoicesSettlementModal);
